export default __webpack_public_path__ + "static/media/HEADERS-Foundation.a8f6f4f3.png";